import React, { FC, PropsWithChildren } from 'react';

import { AliceApp } from 'client/model/skill';

import { AliceAppTitle } from '../AliceAppTitle/AliceAppTitle';

import styles from './Layout.module.scss';

type Props = PropsWithChildren<{ aliceApp: AliceApp; pageTitle: string; hideAtMobile?: boolean }>;

export const PageLayout: FC<Props> = ({ aliceApp, pageTitle, children, hideAtMobile = false }) => {
    return (
        <>
            <AliceAppTitle aliceApp={aliceApp} hideAtMobile={hideAtMobile} />
            <div className={styles.pageLayout__container}>
                <h1 className={styles.pageLayout__header}>{pageTitle}</h1>
                {children}
            </div>
        </>
    );
};
